import { TRANSLATION_KEYS } from '../../i18n/index.enum';

export const selectFilter = (translation) => [
  {
    id: 'model',
    option: [
      {
        label: translation(TRANSLATION_KEYS.HOMEPAGE.FILTERS.FILTER_MODELLO.LABEL_SELECTED),
        value: null,
        selected: true,
        disabled: true,
      },
    ],
  },
  {
    id: 'external_color',
    option: [
      {
        label: translation(TRANSLATION_KEYS.HOMEPAGE.FILTERS.FILTER_COLORE_ESTERNI.LABEL_SELECTED),
        value: null,
        selected: true,
        disabled: true,
      },
    ],
  },
]
